<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-danger btn-block">
        <li class="fa fa-recycle"></li> DESABILITAR ALERTA DE VIBRAÇÃO
    </button>
</template>
<script>
    import { Comandos } from '../../class';
    import { Bus } from '../../class/bus';
    export default {
        name: 'DesabilitarAlertaVibracao',
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.habiliarAlertaVibracao(this.id_rastreador, false);
                Bus.$emit('comandos');
            }
        }
    }
</script>
